@if (label) {
  <label
    [for]="formsControl?.id"
    class="fw-bold mb-0"
    wlAutomationId="non-floating-label"
    >{{ label }}</label
  >
}
<div
  #trackingWrapper
  [wlTrackValueChange]="{
    rendering: rendering,
    label: fieldName || '',
    inputLabel: radioTrackingValue,
    sendValue: sendValue,
    hashValue: hashValue,
    trackFocus: false,
    stepName: stepName,
    step: step || 0,
  }"
>
  @for (radio of radioItems; track trackRadio(i, radio); let i = $index) {
    <div [wlAutomationId]="formsControl?.id">
      <label
        [wlAutomationId]="getId(radio, i)"
        class="form-check-label"
        [for]="getId(radio, i)"
        wlCSCapture
      >
        <div class="d-flex flex-row border border-1 rounded-1 p-1 mb-1">
          <div class="my-auto me-1">
            <ng-container
              *ngTemplateOutlet="
                radio.disabled ? disabledInput : formsControlInput;
                context: {
                  $implicit: radio,
                  index: i,
                  formsControl: formsControl,
                  firstEnabledRadioIndex: firstEnabledRadioIndex,
                }
              "
            ></ng-container>
          </div>
          <div class="d-flex flex-column">
            <div>
              <span [class.pe-1]="radio.tooltip?.description">{{
                radio.label
              }}</span>
              @if (radio.tooltip) {
                <wl-tooltip [tooltip]="radio.tooltip"></wl-tooltip>
              }
            </div>
            @if (radio.sublabel) {
              <small
                class="text-body-secondary d-block"
                *wlGenericRichText="radio.sublabel"
              >
              </small>
            }
          </div>
        </div>
      </label>
    </div>
  }
</div>

<ng-template
  #disabledInput
  let-radio
  let-index="index"
  let-formsControl="formsControl"
>
  @if (formsControl) {
    <input
      disabled
      data-disabled="true"
      type="radio"
      [name]="formsControl.id"
      [id]="getId(radio, index)"
      [value]="radio.value"
    />
  }
</ng-template>

<ng-template
  #formsControlInput
  let-radio
  let-index="index"
  let-formsControl="formsControl"
  let-firstEnabledRadioIndex="firstEnabledRadioIndex"
>
  @if (formsControl) {
    <input
      class="form-check-input"
      [ngrxFormControlState]="formsControl"
      type="radio"
      [name]="formsControl?.id"
      [id]="getId(radio, index)"
      [value]="radio.value"
      (focus)="onFocus()"
      (change)="onChange($event)"
      [ngrxEnableFocusTracking]="index === firstEnabledRadioIndex"
      [wlValidationClasses]="formsControl"
    />
  }
</ng-template>
